import { string, arrayOf, shape } from 'prop-types';

export const item = shape({
    icon: string,
    id: string.isRequired,
    label: string,
});

export const items = arrayOf(item);
